// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardFilledSvg from "@fishx/icons-svg/es/asn/DashboardFilled";
import FishxIcon from '../components/FishxIcon';

var DashboardFilled = function DashboardFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardFilledSvg
  }));
};

DashboardFilled.displayName = 'DashboardFilled';
export default React.forwardRef(DashboardFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DashboardFilled.js
// module id = 2367
// module chunks = 0